/* Compact native accordions: opening a group moves the following items naturally. */
document.addEventListener('toggle', function (event) {
  const node = event.target;
  if (!(node instanceof HTMLDetailsElement) || !node.matches('.bn-menu-group') || !node.open) return;
  Array.from(node.parentElement.children).forEach(sibling => {
    if (sibling !== node && sibling instanceof HTMLDetailsElement && sibling.matches('.bn-menu-group')) sibling.open = false;
  });
}, true);
document.addEventListener('click', function (event) {
  document.querySelectorAll('.nav > .bn-menu-group[open]').forEach(node => {
    if (!node.contains(event.target)) node.open = false;
  });
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const group = document.activeElement?.closest('.bn-menu-group[open]');
  if (group) { group.open = false; group.querySelector('summary').focus(); event.preventDefault(); }
});
